import React from 'react';
import styles from './ArticlePreview.module.scss'
import { formatArticleDate } from '../dataHelpers';
import DraftHTML from "../../../components/draftEditor/export/DraftHTML";
import Link from 'next/link'
import { ENV_LOCAL, URL_BASE, URL_UPLOADED_PICTURES_FOLDER } from "../../../settings/global";
import AspectRatioBox from "../../../components/AspectRatioBox";
import Image from "next/image";
import { NAV_BLOG } from "../../../settings/navigation";

function ArticlePreview({view, article}) {

    const articleURI = `${NAV_BLOG}/${article.slug}`;

    const renderImage = () => {

        const {image_preview} = article;

        if (!image_preview || !image_preview.source) return null;
        // const pictureURL = !image_preview.internal
        //     ? image_preview.source
        //     : 'https://dev.try.direct/files' + '/' + image_preview.source
        //     // : `${URL_UPLOADED_PICTURES_FOLDER + '/'}${image_preview.source}`
        // ;
        // const pictureURL = `${!!image_preview?.internal ? `${URL_BASE}${URL_UPLOADED_PICTURES_FOLDER}/` : ''}${image_preview?.source}`;
        let pictureURL = `${!!image_preview?.internal ? `${URL_UPLOADED_PICTURES_FOLDER}/` : ''}${image_preview?.source}`;

        if (ENV_LOCAL && !!image_preview?.internal) pictureURL = URL_BASE + pictureURL;
        // const pictureURL = `/${image_preview?.source}`;

        // console.log('=================')
        // console.log(image_preview)
        // console.log(image_preview.source.includes('try.direct'))
        // console.log(image_preview.width)
        // console.log(image_preview.height)

        return (
            <AspectRatioBox className={styles.picture} ratio={view === 'list' ? [1, 1] : [1.91, 1]}>
                <div className={styles.picture__container}>
                    <Image
                        className={styles.picture__container__image}
                        src={pictureURL}
                        alt={'Article preview image'}
                        // width={image_preview.width}
                        // height={image_preview.height}
                        style={{
                            objectFit: 'cover',
                            objectPosition: 'center center',
                        }}
                        quality={100}
                        sizes="(max-width: 256px) 25vw, (max-width: 384px) 50vw, (max-width: 640px) 40vw, (max-width: 750px) 50vw, (max-width: 828px) 45vw, (max-width: 1080px) 45vw, (max-width: 1200px) 38vw, (max-width: 1920px) 22vw, (max-width: 2048px) 23vw, (max-width: 3840px) 18vw, 18vw"
                        fill={true}
                    />
                    {
                        // image_preview.source.includes('try.direct') && image_preview.width && image_preview.height
                        //     ?

                            // :
                            // <img
                            //     className={styles.picture__container__image}
                            //     src={pictureURL}
                            //     alt={'Article preview image'}
                            //     width={image_preview.width}
                            //     height={image_preview.height}
                            //     optimize
                            // />
                    }
                </div>
            </AspectRatioBox>
        )
    }

    const pictureExists = !!article?.image_preview?.source;
    const {createdDate} = formatArticleDate(article.created, article.updated);

    return (
        <div className={styles.article} data-article-image-exists={pictureExists}>
            <Link
                href={articleURI}
                className={styles.article__link}
                aria-hidden="true"
                tabIndex='-1'
            >

            </Link>
            {renderImage()}
            <div className={styles.article__content}>
                <Link href={articleURI} className={styles.title} tabIndex='0'>

                    <h2 className={styles.title__heading}>
                        {article.title || 'Untitled'}
                    </h2>

                </Link>
                {/*<DraftHTML*/}
                {/*    content={article.preview}*/}
                {/*    className={styles.description}*/}
                {/*/>*/}
                <DraftHTML
                    className={`content-editor blog-article ${styles.description}`}
                    content={article.preview}
                />
                {!!createdDate && <time className={styles.time}>{createdDate}</time>}
            </div>
        </div>
    );
}

export default ArticlePreview